<script>
import DriverShiftDetailComponent from '@/components/DriverShiftDetailComponent'
import MainLayout from '@/router/layouts/mainLayout'
import dialog from '@/components/Dialog'
export default {
  components: {
    DriverShiftDetailComponent, MainLayout, 'v-dialog': dialog
  },
  created () {
    if (sessionStorage.getItem('shiftDetail') !== null) {
      this.eventId1 = JSON.parse(sessionStorage.getItem('shiftDetail')).shiftInfo.eventId
    }
  },
  data () {
    return {
      shiftMovementFlag: false,
      shiftId: '',
      eventId1: '',
      showDialog: '',
      showDialogOfShift: '',
      // backName: (this.$route.query.from === 'MovementStatus') || (this.$route.query.from === 'MovementShift') ? '運行便に戻る' : 'スケジュールに戻る'
      backName: 'スケジュールに戻る'
    }
  },
  methods: {
    cancel (val1, val2) {
      this.showDialogOfShift = true
      this.$refs.dialogOfShift.confirm().then(() => {
        this.$axios.get('shift/deleteRelatedInfoOfShift', {params: {shiftId: val1, eventId: val2}})
          .then(response => {
            this.$router.go(-2)
          })
          .catch(function () {
            alert('404 Not Found')
          })
        this.showDialogOfShift = false
      }).catch(() => {
        this.showDialogOfShift = false
      })
    },
    getShiftId (val, flag) {
      console.log('shiftDetailComponent flag is ' + flag)
      this.shiftId = val
      this.shiftMovementFlag = flag
      console.log('shiftwithevent flag is ' + this.shiftMovementFlag)
    },
    eventEdit () {
      this.$router.push({ path: '/EventGenerate' })
    },
    eventDelete (val) {
      this.showDialog = true
      this.$refs.dialog.confirm().then(() => {
        this.$axios.get('shift/deleteShiftEventById', {params: {eventId: val}})
          .then(response => {
            let aaa = JSON.parse(sessionStorage.getItem('shiftDetail'))
            aaa.shiftInfo.eventId = null
            sessionStorage.setItem('shiftDetail', JSON.stringify(aaa))
            location.reload()
          })
          .catch(function (error) {
            console.log(error)
          })
        this.showDialog = false
      }).catch(() => {
        this.showDialog = false
      })
    },
    shiftEdit () {
      // this.$router.push({ path: '/EventGenerate' })
    }
  }
}
</script>
<template>
<main-layout>
  <driver-shift-detail-component
    :backName="backName"
    :rightTopBtn= true
    :mapBtnVisibility= true
    @transShiftId="getShiftId"
    >
  </driver-shift-detail-component>
</main-layout>
</template>
<style lang="css" scoped>
  /* @import "../../assets/css/C00.css"; */
.window-button-percent{
  width: 100%;
  height: 40px;
  border-radius: 20px;
  border: none;
  font-size: 20px;
  color: rgb(243, 239, 239);
  background-color: #717171;
  }
</style>



// WEBPACK FOOTER //
// src/router/views/DriverShiftWithEventDetail.vue